import React from 'react';
import PropTypes from 'prop-types';
import { Container, Wrapper, Payment } from './index.view';
import { BaseChildrenProps } from 'baseTypes';

const PaymentSection = ({ children }: BaseChildrenProps) => {
  return (
    <Wrapper>
      <Container>
        <Payment>{children}</Payment>
      </Container>
    </Wrapper>
  );
};
PaymentSection.propTypes = {
  children: PropTypes.node,
};
export default PaymentSection;
